import React, { Component } from "react";
import Slider from "react-slick";

import { useHistory, Link } from "react-router-dom";

import Breadcrumb from "../common/breadcrumb";
import { Helmet } from "react-helmet";
import { Slider2, Team4 } from "../../services/script";
import {
  makeStyles,
  Typography,
  Container,
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.white,
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginTop: "100px",
    },
    fontFamily:"Times New Roman",
    fontSize:"12px"
  },
  title: {
    // width: "40%",
    // height: "auto",
    // objectFit: "cover",
    // [theme.breakpoints.down("xs")]: {
    //     width: "60%",
    // },
    fontSize: "40px",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    // marginLeft: "25%",
    textAlign: "center",
  },
  footertitle: {
    // },
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    textAlign: "center",
  },

  eklogo: {
    width: "350px",
    height: "100px",

    marginInline: "auto",
  },
}));

const vacRules = () => {
  const classes = useStyles();
  const createSpace = () => (
    <span style={{ visibility: "hidden" }}>{".".repeat(10)}</span>
  );
  return (
    <div>
      <Helmet>
        <title>eksplode | Official Vac Rules</title>
      </Helmet>
      <Breadcrumb title={"Vac Rules"} />
      <section className="about-page  section-b-space">
        <div className="container">
          <div className="row">
            {/* <div className='col-lg-12'>
                <div className='banner-section d-flex justify-content-center'>
                <img
                src={`${process.env.PUBLIC_URL}/assets/images/mega-menu/.jpeg`}
                className='img-fluid'
                    alt=''
                  />
                </div>
              </div> */}

            <div className="col-sm-12">
              {/* <h4>VAC RULES</h4> */}

              {/* <p className='mt-5 mb-4'>VAC RULES HERE!</p>
               */}
              <Grid style={{ minHeight: "100vh" }} container>
                <div id="vacrules" className={classes.root}>
                  <Container maxWidth="md" >
                    <Box mb={2} className={classes.title}>
                      <img
                        className={classes.eklogo}
                        src="/assets/images/icon/logo-eksplode.png"
                        alt="eksplode!"
                      />
                    </Box>
                    <div style={{ textAlign: "center" }}>
                      <br />
                      <strong style={{color:"black", fontSize:"12px", fontFamily:"Times New Roman"}}>VIDEO AD CONTEST</strong>
                      <br/>
                      <br/>
                      <strong style={{color:"black", fontSize:"12px", fontFamily:"Times New Roman"}}>OFFICIAL RULES</strong>
                      <br />
                      <br/>
                    </div>
                    <p style={{color:"black", fontSize:"12px", fontFamily:"Times New Roman"}}>
                      NO PURCHASE IS NECESSARY TO ENTER OR WIN. PURCHASE WILL
                      NOT INCREASE YOUR CHANCES OF WINNING. VOID WHERE
                      PROHIBITED BY LAW.
                    </p>

                    <Box textAlign="justify">
                      <br />
                      <Typography variant="body1" style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        1.
                        <span style={{ fontWeight: "bold" }}>
                          {createSpace()} Eligibility:{" "}
                        </span>
                        Open to legal residents of the United States, including
                        the District of Columbia, Guam, American Samoa, U.S.
                        Virgin Islands, and Puerto Rico, who are (i) eighteen
                        (18) years of age or older, or (ii) are the age of the
                        majority in their respective
                        states/jurisdictions/territories (whichever is greater)
                        as of the date of entry. Employees and their immediate
                        family members (parents, siblings, children and spouse,
                        and persons residing in the same household, whether
                        related or not) of Continent 5 Media Group, Inc.
                        (hereinafter "Sponsor") and its parent and affiliated
                        companies, subsidiaries, and advertising and promotion
                        agencies, and all other companies associated with the
                        eksplode! Video Ad Contest (hereinafter "VAC"), and
                        their respective officers, directors, and agents, and
                        all individuals, including, but not limited to,
                        consultants, independent contractors, so-called
                        "temporary employees," former employees and interns (and
                        their immediate family members) who have, within the
                        past six months, performed services for Sponsor, are not
                        eligible to enter or win. Void where prohibited by law.
                        ALSO OPEN TO ENTRANTS WHO ARE BETWEEN THIRTEEN (13) AND
                        EIGHTEEN (18) YEARS OF AGE IF THEY MEET THE OTHER
                        ELIGIBILITY REQUIREMENTS ABOVE AND IF THEY PROVIDE THE
                        VERIFIABLE WRITTEN CONSENT OF THEIR PARENT OR LEGAL
                        GUARDIAN (except that residents of Massachusetts under
                        eighteen (18) years of age are not eligible to enter or
                        win). (
                        <Link href="https://www.here.com/">Click HERE</Link> to
                        download the Parental Consent Form at:{" "}
                        <Link href="https://Continent5Media.com">
                          Continent5Media.com
                        </Link>{" "}
                        or
                        <Link href="https://C5M.world"> C5M.world</Link>).
                      </Typography>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        2.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Contest Period and Rounds:
                        </span>{" "}
                        The eksplode! VAC begins on June 1, 2023, at 12:01 a.m.
                        PDT and ends on June 30, 2024, at 11:59 p.m. PDT, and
                        consists of the following twelve (12) separate rounds
                        (each one a "Round"):
                        <br />
                        <br />
                        <span>
                          Round No. 1: June 1, 2023, at 12:01 a.m. PDT and ends
                          on June 30, 2023, at 11:59 p.m. PDT.
                          <br />
                          Round No. 2: July 1, 2023, at 12:01 a.m. PDT and ends
                          on July 30, 2023, at 11:59 p.m. PDT.
                          <br />
                          Round No. 3: August 1, 2023, at 12:01 a.m. PDT and
                          ends on August 30, 2023, at 11:59 p.m. PDT.
                          <br />
                          Round No. 4: September 1, 2023, at 12:01 a.m. PDT and
                          ends on September 30, 2023, at 11:59 p.m. PDT.
                          <br />
                          Round No. 5: October 1, 2023, at 12:01 a.m. PDT and
                          ends on October 30, 2023, at 11:59 p.m. PDT.
                          <br />
                          Round No. 6: November 1, 2023, at 12:01 a.m. PDT and
                          ends on November 30, 2023, at 11:59 p.m. PST.
                          <br />
                          Round No. 7: December 1, 2023, at 12:01 a.m. PST and
                          ends on December 30, 2023, at 11:59 p.m. PST.
                          <br />
                          Round No. 8: January 1, 2024, at 12:01 a.m. PST and
                          ends on January 30, 2024, at 11:59 p.m. PST.
                          <br />
                          Round No. 9: February 1, 2024, at 12:01 a.m. PST and
                          ends on February 28, 2024, at 11:59 p.m. PST.
                          <br />
                          Round No. 10: March 1, 2024, at 12:01 a.m. PST and
                          ends on March 30, 2024, at 11:59 p.m. PDT.
                          <br />
                          Round No. 11: April 1, 2024, at 12:01 a.m. PDT and
                          ends on April 30, 2024, at 11:59 p.m. PDT.
                          <br />
                          Round No. 12: May 1, 2024, at 12:01 a.m. PDT and ends
                          on May 30, 2024, at 11:59 p.m. PDT.
                        </span>
                        <br />
                        <br />
                        Additional Rounds, if any, will be announced on
                        eksplode!'s website from time to time. The number of
                        additional Rounds, if any, and the opening and closing
                        dates and times for each additional Round will be
                        determined by the Sponsor or Sponsor's designee in its
                        sole and absolute discretion
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        3.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Consideration to Entrant:{" "}
                        </span>
                        In consideration of the rights assigned by entrants to
                        Sponsor and the other representations, warranties,
                        indemnities, and obligations of entrants under these
                        Official Rules, Sponsor will pay each eligible entrant
                        One Dollar ($1.00) for each video accepted by Sponsor
                        pursuant to Sections 4 and 5 below for the eksplode!
                        VAC, whether or not the entrant is a winner. Entrants
                        also acknowledge that the opportunity to enter the
                        eksplode! VAC represents consideration given by Sponsor.
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        4.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          How to Enter:
                        </span>{" "}
                        To enter the eksplode! VAC, entrants (each one an
                        "Entrant") must do the following:
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (a) Sign up at{" "}
                          <Link href="https://eksplode.com/">eksplode.com</Link>{" "}
                          to become an eksplode! Star, receive your eksplode!
                          Code and access your Workshop page.
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (b) Select one (1) item from the list of products
                          offered by participating retailers (each one a
                          "Retailer" and collectively "Retailers"), which is
                          accessible on the Star’s Workshop page.
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (c) Record a promotional video (each one a
                          "Video")—with a running time of not less than fifteen
                          (15) seconds and not more than thirty (30)
                          seconds—featuring the item that the Entrant selected
                          from the Participating Retailers’ page.
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (d) Submit your Video at least seven (7) calendar days
                          prior to the Round selected by the Entrant to compete
                          in by uploading the digital file through the portal
                          located on each Star's Workshop page. By way of
                          example only, a Video intended to compete for the
                          Round of November 1, 2023, must be submitted by 11:59
                          p.m. PDT on October 24, 2023, and a Video intended to
                          compete for the Round of December 1, 2023, must be
                          submitted by 11:59 p.m. PST on November 23, 2023.{" "}
                        </span>
                        <br />
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        5.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          General Information:
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (a) Here’s how it works: Retailers post a cash amount
                          next to selected products listed on their eksplode!
                          Catalog, which is accessible to eksplode! Stars on
                          their dashboards. The Star chooses a product from that
                          list, creates a video, then uploads it onto
                          eksplode!’s platform. No matter how many Videos are
                          submitted for the same product, the Star with the most
                          votes at the end of the Contest Round wins the cash
                          amount posted.{" "}
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (b) There is no charge to compete in eksplode!’s VAC.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (c) No professional actors, singers, musicians, or
                          other performers may appear in the Video.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (d) The Video must be produced by the Entrant, who
                          will be solely responsible and liable for the
                          compensation and conduct of any production crew
                          members that the Entrant may elect to use.{" "}
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (e) All aspects of the Video must strictly comply with
                          the terms of Section 10 below.{" "}
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (f) eksplode! VAC Videos are essentially amateur
                          commercials meant to inform the viewer of a product
                          while doing so in an entertaining and memorable way.
                          Each performance should be funny (even silly) while
                          telling the viewer about the featured product, how
                          wonderful it is, and why they should (or need to) have
                          it.{" "}
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (g) The Video you decide to create may: (i) include
                          your original music, song, or recorded sounds or music
                          selected from the Galaxie Music Library (available on
                          your Workshop page), (ii) be recorded on any device,
                          including smartphones (picture quality is not a
                          qualifying factor, but your viewers must be able to
                          identify the product you are featuring), and (iv)
                          include other performers of any age group.{" "}
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (h) The Video you decide to create may NOT: (i)
                          display logos, icons, slogans, emblems, or designs
                          from another retailer, brand, manufacturer, or
                          company, (ii) involve any dangerous acts or stunts,
                          (iii) involve violence of any type, (iv) include or
                          involve any mention, statement, or comment about,
                          concerning, or regarding other products, items,
                          services, or retailers, (v) include or involve any
                          mention, statement, or comment about, concerning, or
                          regarding any competing Video or a competing Entrant,
                          (vi) include music or background sounds that Entrant
                          did not create or obtain written authorization from
                          the owner to use, (vii) include nudity, partial
                          nudity, sexually graphic content, or offensive or
                          vulgar language, (viii) include any mention of
                          religion, politics, or race, and (ix) include
                          unknowing or unwitting participants, bystanders, or
                          persons. (In other words, everyone appearing in
                          Entrant's Video must consent to such and must have
                          been told that their appearance/performance in the
                          Video will be made available for online viewing and
                          that no compensation whatsoever will be provided by
                          Sponsor or any retailer to such persons.){" "}
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (i) Each timely-submitted Video will be reviewed by
                          the Sponsor to ensure: (i) compliance with these
                          Official Rules, (ii) that the running time of the
                          Video is at least fifteen (15) seconds, (iii) that it
                          sufficiently and appropriately features (showcases)
                          the product listed by the participating retailer, and
                          (iv) that the Video does not violate these Official
                          Rules.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (j) Upon acceptance of a Video, and conditioned on
                          Entrant's strict compliance with all terms outlined in
                          these Official Rules, Entrant will be entitled to
                          receive payment in the amount of One Dollar ($1.00)
                          for each Video submitted.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (k) The terms "accepted" and "acceptance," as used in
                          these Official Rules, mean that Entrant's Video has
                          been screened and found to comply with all criteria
                          outlined in these Official Rules and will be placed in
                          the appropriate Round to compete.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (l) All accepted Video submissions are subject to
                          editing by Sponsor to reduce the overall running time
                          to thirty (30) seconds if needed.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (m) The opening date, closing date, and time of each
                          Round are shown above.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (n) Receipt of entries will not be acknowledged.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (o) Sponsor, retailers, and their employees, agents,
                          and representatives are not responsible or liable in
                          any manner whatsoever for late, incomplete, or
                          misdirected entries, failed or corrupted uploads, or
                          any entries that are uploaded but are later corrupted,
                          lost or missing, regardless of the reason thereof.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (p) Late or incomplete entries that do not comply with
                          the submission requirements outlined in these Official
                          Rules are null and void.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (q) There is no limit to the number of Videos an
                          Entrant may submit promoting the same product, as long
                          as each Video is different in overall concept,
                          content, and production.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (r) An Entrant may submit a Video using the same idea
                          or concept used in a Video previously submitted, as
                          long as it promotes a different product listed on
                          eksplode!'s 'Participating Retailers' page.
                        </span>
                        <br />
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (s) Any Video that Sponsor, in its sole discretion,
                          deems to be inappropriate (including, but not limited
                          to), Videos containing content that infringes or may
                          infringe any third party's intellectual rights of
                          publicity, or content that Sponsor deems to be
                          offensive, defamatory, indecent, disparaging, obscene,
                          pornographic, abusive, harassing, or illegal, or that
                          constitutes an unlawful invasion of privacy, or which
                          in any manner violates these Official Rules), shall be
                          null and void and ineligible to win.
                        </span>
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        6.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          How to Win:{" "}
                        </span>
                        Entries in each Round will be displayed for public
                        viewing on eksplode!'s VAC platform during the entire
                        30-day Round. Visitors to eksplode!'s VAC platform may
                        view the entries and vote for their favorite Video
                        throughout the Round based on the following criteria:
                        (i) originality in concept, (ii) creativity in
                        production, (iii) memorable description, (iv) product
                        positioning, and (v) expression. Votes for each Video
                        will be automatically tabulated and displayed for public
                        viewing. The entry that receives the most votes will be
                        the winner for that Round. The winner will be notified
                        by email or text (whichever format the Entrant selects
                        when signing up) within twenty-four (24) hours following
                        the close of the Round and final tabulation of the vote.
                        In the event of a tie, the prize amount offered for that
                        Round will be divided equally among those entrants with
                        the tying votes. The winning Video(s) in each Round will
                        be posted on eksplode!'s website for at least thirty
                        (30) days after being selected. Only one vote per
                        visitor (IP address) per Round will be allowed and
                        counted. Entrant may participate in voting. Losing
                        entries will not be rolled over into any subsequent
                        Round unless Sponsor, in its sole discretion, elects to
                        do so. However, under no circumstances will Entrant be
                        entitled to further payment, but will nevertheless be
                        eligible to win the prize amount offered for that
                        subsequent Round. (Visit eksplode!'s FAQ page of its VAC
                        platform for more details at <Link>eksplode.com</Link>).
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        7.
                        <span style={{ fontWeight: "bold" }}>{createSpace()} Prizes:</span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (a) The winner will receive the cash prize offered by
                          the Retailer whose product is promoted in the winning
                          Video. Each participating Retailer will determine the
                          prize amount at its sole and absolute discretion. A
                          complete list of the cash prize offered by each
                          Retailer will be displayed on their eksplode! VAC
                          catalog before and during each Round.{" "}
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (b) ALL FEDERAL, STATE AND LOCAL TAXES ARE SOLELY THE
                          RESPONSIBILITY OF THE ENTRANTS AND THE WINNERS.{" "}
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (c) Prizes are non-transferable. The awarded prizes
                          are subject to the restrictions and limitations noted
                          in these Official Rules on the prize and/or included
                          with the prize.{" "}
                        </span>
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        8.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Odds of Winning:{" "}
                        </span>{" "}
                        Odds of winning depend on the number of eligible entries
                        received during each Contest Period.
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        9.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          How to collect:{" "}
                        </span>
                        <span>
                          {" "}
                          All payments will be electronically sent to whichever
                          online payment platform the Entrant selects upon
                          registration. Entrant is responsible for paying all
                          fees, if any, charged by the online payment platform
                          selected. Payments to Entrants for Video submission
                          that Sponsor accepts will ordinarily be made within
                          twenty-four (24) hours of Sponsor's review and
                          acceptance of each Video. Payments to VAC winners will
                          ordinarily be made within twenty-four (24) hours of
                          each Round's expiration date and the final tabulation
                          of the votes.
                        </span>
                      </p>

                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        10.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Rights and Respresentions:{" "}
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (a) Entrant hereby assigns to Sponsor and its
                          licensees, successors, and assigns, exclusively and
                          irrevocably, all right, title, and interest in and to
                          the Video(s) that Sponsor accepts for submission,
                          including but not limited to rights under copyright,
                          trademark, patent, and other intellectual property
                          rights, and any physical objects in which the Video
                          may be recorded or otherwise embodied, in any and all
                          media now known or hereafter devised, in any and all
                          languages, throughout the world, and in perpetuity,
                          and waives any moral rights that Entrant is entitled
                          to assert to the maximum extent permitted by law. By
                          way of example only, and without limiting the rights
                          of Sponsor, Entrant acknowledges that Sponsor and
                          Retailer may post, broadcast, publish, distribute, and
                          otherwise exploit the Video, in whole or in part,
                          without the knowledge or further consent of Entrant.
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (b) ENTRANT MAY USE EACH VIDEO ONLY AS AN ENTRY IN THE
                          EKSPLODE! VAC AND FOR NO OTHER PURPOSE WHATSOEVER. BY
                          WAY OF EXAMPLE ONLY, THE ENTRANT MAY NOT POST THE
                          VIDEO ON THE INTERNET OR AUTHORIZE OTHERS TO DO SO.
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (c) Entrant hereby represents and warrants that it
                          owns each Video that Entrant enters in the eksplode!
                          VAC in its entirety, or that it otherwise has the
                          right to grant use thereof as outlined in this
                          section; that it has obtained the requisite consent in
                          writing from the owners of third-party content and
                          thirdparty intellectual property that may appear in
                          the Video, included but not limited to text, music not
                          provided by eksplode! in its Galaxie Music Catalog,
                          and images; and that the posting, distribution, or use
                          of said Video does not violate the privacy rights,
                          publicity rights, copyright, trademark rights,
                          contract rights, or any other rights of any person or
                          entity. Entrant acknowledges and understands there
                          shall be no consideration, royalties, or other
                          compensation from Sponsor, its agents, affiliates, or
                          assigns for the use of said Video or the content
                          therein except as expressly provided in these Official
                          Rules. Entrant hereby agrees to defend, indemnify,
                          discharge, release, and hold the Sponsor, the
                          Retailer, and their respective employees, agents, and
                          representatives harmless from any action or liability,
                          in any form or manner and inclusive of attorneys’ fees
                          and costs, arising from any claim of infringement of
                          any third party’s rights in connection with the Video
                          and/or any breach of Entrant’s representations,
                          warranties and other obligations as outlined in these
                          Official Rules.{" "}
                        </span>
                        <br />
                        <span style={{ margin: "1rem" }}>
                          (d) By entering, all Entrants hereby agree to abide by
                          these Official Rules, including the submission
                          requirements specified above.
                        </span>
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        11.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          General Entery Rules:
                        </span>{" "}
                        Any Entrant who attempts or otherwise encourages,
                        directly or indirectly, entry under multiple identities,
                        accounts, or for a proxy individual, or uses any other
                        device, method, or artifice to enter or encourage,
                        directly or indirectly, multiple or false entries as
                        determined by the Sponsor, will be disqualified. At its
                        sole discretion, the Sponsor reserves the right to
                        review and investigate all entries and take any measures
                        necessary to ensure a fair contest. Lost, corrupted, or
                        incomplete entries that do not conform to these Official
                        Rules will be deemed ineligible, disqualified, and void.
                        In the event of a dispute, entry information will be
                        declared made by the Entrant’s social media account
                        information.
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        12.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Contest Entities:
                        </span>{" "}
                        Sponsor and its subsidiaries and affiliates, advertising
                        and promotion agencies, suppliers, printers, and
                        distributors, and their respective officers, directors,
                        employees, representatives, and agents, and any other
                        person or entity related in any way to the
                        (collectively, the “Contest Entities”), are not
                        responsible for circumstances that may limit or
                        otherwise restrict the ability to participate,
                        including, but not limited to: (i) late or incomplete
                        entries; technical, hardware, or miscellaneous software
                        malfunctions; viruses; network or electronic
                        malfunctions of any kind; (ii) any human error that may
                        occur in winner notification or other contest-related
                        communications; (iii) or for any printing errors in
                        these Official Rules. If a printing, electronic, or
                        other error results in more prizes being claimed than
                        the number stated in these Official Rules, all persons
                        making purportedly valid claims will be included in a
                        random drawing to award the advertised number of prizes
                        available. No more than the advertised number of prizes
                        will be awarded.
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        13.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Reserved Rights of Sponsor:
                        </span>{" "}
                        If for any reason the eksplode! VAC cannot be conducted
                        as described in these Official Rules (including
                        infection by computer virus, bugs, worms, tampering,
                        hacking, unauthorized intervention, fraud, technical
                        failures, or any other cause beyond the reasonable
                        control of Contest Entities that corrupts or affects the
                        administration, security, fairness, integrity, or proper
                        conduct of the eksplode! VAC), then, in such an event,
                        Sponsor shall have the right, at its sole discretion, to
                        cancel, terminate, modify or suspend the eksplode! VAC
                        and randomly select winners from entries received prior
                        to the action taken or as otherwise deemed fair and
                        appropriate by Sponsor. SPONSOR RESERVES THE RIGHT TO
                        PROSECUTE ANY FRAUDULENT ENTRIES OR VOTES TO THE FULLEST
                        EXTENT OF THE LAW. At Sponsor’s sole discretion,
                        Entrants who do not comply with these Official Rules or
                        otherwise attempt to interfere with the eksplode! VAC,
                        in any way, may be disqualified. ALL DECISIONS BY
                        SPONSOR ARE FINAL. IF YOU DO NOT AGREE TO THE TERMS AND
                        CONDITIONS OF THESE OFFICIAL RULES, DO NOT ENTER THE
                        EKSPLODE! VAC.
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        14.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Release and Idemnification:
                        </span>{" "}
                        By entering, Entrants agree to be bound by these
                        Official Rules and the decisions of Sponsor which shall
                        be final for all purposes hereunder, and agree: (i)
                        Sponsor, its parent, subsidiaries, affiliates,
                        advertising and promotion agencies may use, edit, and
                        alter their names, likenesses, images, photographs,
                        voices, cities/states of residence, and biographical
                        information and the prize for advertising, trade and
                        promotion in any media or format now or hereafter known,
                        including on the Internet, including, but not limited
                        to, social media platforms, or via wireless application
                        protocol, without further compensation, permission or
                        notification, except where prohibited by law; (ii)
                        Entrants acknowledge, understand, and agree that each of
                        them assumes liability for, and all risks of, any and
                        all injuries (including without limitation, personal
                        injury, illness, adverse reaction, or death) or damages
                        caused, or claimed to be caused, by participating in the
                        eksplode! VAC or the prize, and that Entrants, their
                        heirs, next of kin, spouse, guardians, legal
                        representatives, executors, administrators, successors,
                        and assigns, hereby unconditionally and irrevocably
                        release and agree to defend, indemnify, forever
                        discharge and hold the Contest Entities, together with
                        Instagram, Facebook and Twitter, harmless from and
                        against any and all claims, demands, liens, agreements,
                        suits, costs, attorneys’ fees, damages, judgments,
                        orders, and liabilities of whatever kind or nature in
                        law, equity or otherwise, whether known or unknown,
                        suspected or unsuspected, and whether or not concealed
                        or hidden inclusive of any claims for damage to
                        property, personal injury, illness, mental illness, or
                        death, or claims based on defamation, rights of privacy,
                        intellectual property rights, and rights of publicity in
                        any way arising directly or indirectly out of the
                        Entrants’ participation in the eksplode! VAC and/or the
                        prize.
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        15.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Waiver of Unknown claims:
                        </span>{" "}
                        Each Entrant hereby waives application of California
                        Civil Code Section 1542 which provides as follows:
                        <br />
                        A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE
                        CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR
                        AT THE TIME OF EXECUTING THE RELEASE, WHICH, IF KNOWN BY
                        HIM, MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH
                        THE DEBTOR. <br />
                        Each Entrant expressly waives the provisions of Section
                        1542 of the California Civil Code as well as any other
                        statutes, rules, laws, ordinances, or common law
                        principles or other authority of similar effect of any
                        jurisdiction, and further waives any right to invoke
                        said provisions now or in the future with regard to the
                        eksplode! VAC. Entrants and the Winners further
                        acknowledge and agree that this waiver is an essential
                        and material term of these Official Rules and the
                        eksplode! VAC.
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        16.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Affidavit and Release:
                        </span>
                        Winners may be required to complete and sign an
                        Affidavit of Eligibility and Publicity/Liability Release
                        (unless prohibited by law) and other documents as
                        determined by Sponsor in its sole discretion. As
                        applicable, Entrant must return the aforementioned
                        materials to Sponsor or Sponsor’s representatives, or
                        the prize may be forfeited and awarded to the next
                        eligible entrant selected.
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        17.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          ARBITRATION CLAUSE:
                        </span>{" "}
                        EXCEPT TO THE EXTENT PRE-EMPTED BY FEDERAL OR OTHER
                        APPLICABLE STATE LAW, THE EKSPLODE! VAC SHALL BE
                        GOVERNED BY THE LAWS OF THE STATE OF CALIFORNIA WITHOUT
                        GIVING EFFECT TO ANY CONFLICT OF LAW PROVISIONS THEREOF.
                        ENTRANTS UNDERSTAND AND AGREE THAT ALL CLAIMS, DISPUTES,
                        OR CONTROVERSIES BETWEEN ENTRANT AND THE CONTEST
                        ENTITIES SHALL BE RESOLVED BY FINAL AND BINDING
                        ARBITRATION IN THE COUNTY OF LOS ANGELES, STATE OF
                        CALIFORNIA. BY ENTERING, ENTRANTS VOLUNTARILY AND
                        KNOWINGLY WAIVE ANY RIGHT THEY HAVE TO A JURY
                        TRIAL. THIS ARBITRATION CONTRACT IS MADE PURSUANT TO A
                        TRANSACTION IN INTERSTATE COMMERCE, AND ITS
                        INTERPRETATION, APPLICATION, ENFORCEMENT, AND
                        PROCEEDINGS HEREUNDER SHALL BE GOVERNED BY THE FEDERAL
                        ARBITRATION ACT (“FAA”) AND CONDUCTED BY JUDICIAL
                        ARBITRATION AND MEDIATION SERVICES, INC. (“JAMS”), IN
                        ACCORDANCE WITH THE JAMS COMPREHENSIVE ARBITRATION
                        RULES. THE TRIBUNAL WILL CONSIST OF ONE ARBITRATOR. THE
                        PREVAILING PARTY SHALL BE ENTITLED TO AN AWARD OF ITS
                        REASONABLE ATTORNEYS’ FEES AND ACTUAL COSTS INCURRED IN
                        SUCH ACTION. THE ARBITRATOR SHALL BE BOUND TO APPLY AND
                        ENFORCE THE OFFICIAL RULES ‘ TERMS, AND THE ARBITRATOR’S
                        DECISION WILL BE FINAL, BINDING, AND ENFORCEABLE IN A
                        COURT OF COMPETENT JURISDICTION.  NEITHER ENTRANT NOR
                        SPONSOR SHALL BE ENTITLED TO JOIN OR CONSOLIDATE CLAIMS
                        IN ARBITRATION BY OR AGAINST OTHER CONSUMERS OR
                        ARBITRATE ANY CLAIM AS A REPRESENTATIVE OR MEMBER OF A
                        CLASS.    FURTHER, IN ANY SUCH DISPUTE, UNDER NO
                        CIRCUMSTANCES WILL ENTRANTS BE PERMITTED TO OBTAIN
                        AWARDS FOR, AND THEY HEREBY WAIVE ALL RIGHTS TO CLAIM
                        PUNITIVE, INCIDENTAL, OR CONSEQUENTIAL DAMAGES (OTHER
                        THAN ACTUAL OUT-OFPOCKET EXPENSES). THEY FURTHER WAIVE
                        ALL RIGHTS TO HAVE DAMAGES MULTIPLIED OR INCREASED.
                      </p>
                      <br />
                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        18.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Digital Millennium Copyright Act:
                        </span>
                        Pursuant to the Digital Millennium Copyright Act, if an
                        individual or an entity has a good faith belief that a
                        Submission infringes upon any third-party copyright,
                        please notify us by email at{" "}
                        <Link>admin@Continent5Media.com</Link> or{" "}
                        <Link>admin@C5M.world</Link> with the subject line
                        stating “Copyright.” The DMCA notice MUST include the
                        following: (i) a description of the alleged infringement
                        in detail; (ii) the name of the copyright owner or party
                        who retains authorized use; (iii) the URL(s) where the
                        alleged infringement can be located; (iv) a statement
                        indicating your authorization to file a DMCA complaint;
                        (v) how you may be contacted; and (vi) the following
                        statement:
                        <br />
                        “I have a good faith belief that use of the copyrighted
                        material described above is not authorized by the
                        copyright owner or its agent, nor is such use otherwise
                        permissible under law. I declare, under penalty of
                        perjury, that the information presented herein is
                        accurate, that I am authorized to represent the
                        copyright holder, and that I have a good faith belief
                        that the use is infringing.”
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        19.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Winners List and Official Rules:
                        </span>{" "}
                        You may request the name of the winners in each Round by
                        sending a self-addressed, stamped envelope to Sponsor at
                        the address below, Attn: eksplode! Video Ad Contest.
                        During each Round, Official Rules requests may be sent
                        to the same address. Rules requests must include a
                        self-addressed, stamped envelope. Residents of Vermont
                        may omit return postage for rules requests.
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        20.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Privacy Policy:
                        </span>{" "}
                        Personal information provided by the Entrant to enter
                        the eksplode! VAC is subject to the Sponsor’s Privacy
                        Policy, which can be found at{" "}
                        <Link href="https://Continent5Media.com">
                          Continent5Media.com
                        </Link>{" "}
                        or <Link href="https://C5M.world">C5M.world</Link>.
                        Instagram, Facebook, and Twitter retain their own
                        privacy policies, and Sponsor is not responsible for the
                        terms and conditions thereof.
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        21.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Sponsor:
                        </span>{" "}
                        Continent 5 Media Group, Inc., 8 The Green, Suite
                        #13710, Dover, DE 19901.
                      </p>
                      <br />

                      <p style={{ fontFamily:"Times New Roman",
    fontSize:"12px", lineHeight: "1em", color:"black"}}>
                        22.
                        <span style={{ fontWeight: "bold" }}>
                        {createSpace()}
                          Copyright and Trademark Notice:
                        </span>{" "}
                        The eksplode! VAC and all accompanying materials are
                        Copyright 2022 by Continent 5 Media Group, Inc., a
                        Delaware Corporation. All rights reserved.
                      </p>
                      <br />

                      <br />
                      <div className="row">
                        <a
                          target="_blank"
                          href={`${process.env.REACT_APP_VAC}/register/star`}
                          className="btn btn-solid mb-3 mt-3 ml-3 float-right"
                        >
                          Visit VAC
                        </a>
                      </div>
                    </Box>
                  </Container>
                </div>
              </Grid>
            </div>
          </div>
          {/* <div className='row'>
            <a
              target='_blank'
              href={`${process.env.REACT_APP_VAC}/register/star`}
              className='btn btn-solid mb-3 mt-3 ml-3 float-right'
            >
              Visit VAC
            </a>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default vacRules;
